import { decryptString } from '@/utils/helperFunction'
import { DECRYPT_KEY } from '@/defaults'

export const decryptInterceptor = (response) => {
  if (DECRYPT_KEY && response.data) {
    response.data = decryptString(DECRYPT_KEY, response.data)
  }
  return response
}
